module.exports = __webpack_public_path__ + "static/feature-record@2x-df08ebe35a139498d34c1ab3172f877d.gif";